import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  FaRocket, 
  FaCalendar, 
  FaUsers, 
  FaBed, 
  FaRupeeSign, 
  FaChartLine, 
  FaShieldAlt, 
  FaCheckCircle,
  FaBuilding,
  FaTools
} from 'react-icons/fa';
import './Home.css';

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-container">
          <div className="hero-content">
            <h1 className="hero-title">
              Simplify Your PG & Hostel Management
            </h1>
            <p className="hero-subtitle">
              Complete digital solution for managing paying guests, rooms, payments, and operations - all in one place
            </p>
            <div className="hero-buttons">
              <button onClick={() => navigate('/login')} className="btn-primary">
                <FaRocket /> Get Started Free
              </button>
              <button onClick={() => navigate('/contact')} className="btn-secondary">
                <FaCalendar /> Schedule Demo
              </button>
            </div>
            <div className="hero-stats">
              <div className="stat-item">
                <span className="stat-number">1,000+</span>
                <span className="stat-label">Guests Managed</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">99.9%</span>
                <span className="stat-label">Uptime</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="section-container">
          <div className="section-header">
            <h2>Powerful Features for Complete Management</h2>
          </div>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <FaUsers />
              </div>
              <h3>Guest Management</h3>
              <p>Complete guest lifecycle from registration to checkout with detailed profiles and documentation</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <FaBuilding />
              </div>
              <h3>Building Management</h3>
              <p>Manage multiple properties, rooms, and facilities with real-time availability tracking</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <FaBed />
              </div>
              <h3>Bed Management</h3>
              <p>Smart bed allocation, maintenance scheduling, and occupancy optimization</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <FaRupeeSign />
              </div>
              <h3>Invoicing & Payments</h3>
              <p>Automated billing, payment tracking, and integration with popular payment gateways</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <FaTools />
              </div>
              <h3>Complaint Management</h3>
              <p>Streamlined ticket system for handling guest complaints and maintenance requests</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <FaChartLine />
              </div>
              <h3>Reports & Analytics</h3>
              <p>Comprehensive dashboards and reports for insights into occupancy and revenue</p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="section-container">
          <div className="section-header">
            <h2>Why Choose RentTick?</h2>
            <p>Built specifically for PG and hostel owners</p>
          </div>
          
                    <div className="benefits-grid">
            <div className="benefit-item">
              <FaCheckCircle />
              <div>
                <h4>Easy to Use</h4>
                <p>Intuitive interface designed for non-technical users</p>
              </div>
            </div>
            <div className="benefit-item">
              <FaCheckCircle />
              <div>
                <h4>Cloud-Based</h4>
                <p>Access from anywhere, anytime on any device</p>
              </div>
            </div>
            <div className="benefit-item">
              <FaCheckCircle />
              <div>
                <h4>Secure & Reliable</h4>
                <p>Enterprise-grade security with regular backups</p>
              </div>
            </div>
            <div className="benefit-item">
              <FaCheckCircle />
              <div>
                <h4>Affordable Pricing</h4>
                <p>Flexible plans that fit businesses of all sizes</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-container">
          <h2>Ready to Streamline Your Operations?</h2>
          <p>Join hundreds of PG and hostel owners who trust RentTick</p>
          <div className="cta-buttons">
            <button onClick={() => navigate('/login')} className="btn-light">
              <FaRocket /> Start Free Trial
            </button>
            <button onClick={() => navigate('/contact')} className="btn-outline">
              <FaCalendar /> Talk to Sales
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
